globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};

appCustomerSpace.Modules.PlatformPaymentIframe = (function() {
  function PlatformPaymentIframe($iframeContainer, options) {
    this.$iframeContainer     = $iframeContainer;
    this.$iframe              = this.$iframeContainer.find("iframe")
    this.$form                = this.$iframeContainer.find("form");
    this.origin               = this.$iframe.data("origin");
    this.checkUrl             = this.$iframeContainer.data("deals-check-url");

    this.messageCodesCallback = options.messageCodesCallback;
    this.messageTypesCallback = options.messageTypesCallback;

    this.messagesMapping      = {
      "001": { type: "INFO",    msg: "Subscription process has been started" },
      "002": { type: "ERROR",   msg: "The account is not setup in the admin" },
      "003": { type: "ERROR",   msg: "There is no deal ready to be signed" },
      "004": { type: "ERROR",   msg: "Client asked to stop process" },
      "101": { type: "INFO",    msg: "Invoicing informations are valid. Payment step has started" },
      "102": { type: "ERROR",   msg: "Invoicing informations are invalid. Client has stated he could not provide a valid address" },
      "103": { type: "ERROR",   msg: "Client asked for a specific VAT. This has to be configured within the ADMIN" },
      "201": { type: "INFO",    msg: "Payment method saved. Payment step has started" },
      "202": { type: "ERROR",   msg: "Payment method not saved. Client has stated he could not proceed" },
      "301": { type: "INFO",    msg: "Payment started" },
      "302": { type: "INFO",    msg: "Payment failure. Client is asked to retry" },
      "303": { type: "ERROR",   msg: "Payment failed. Client has stated he could not proceed to payment" },
      "401": { type: "INFO",    msg: "Second payment method successfully retrieved" },
      "402": { type: "INFO",    msg: "Second payment method has not been retrieved but the process continues anyway" },
      "501": { type: "SUCCESS", msg: "The deals have been successfully subscribed" },
      "502": { type: "SUCCESS", msg: "The deals have been partially subscribed" }
    };
  }

  PlatformPaymentIframe.init = function($iframe, options) {
    var module = new PlatformPaymentIframe($iframe, options);
    module.init();
  }

  PlatformPaymentIframe.prototype = {
    init: function() {
      var _this     = this;
      var attempts  = 1;
      appCustomerSpace.Loader().start({ $container: _this.$iframeContainer, options: { style: { backdrop: { background: "#fff" }} } });
      _this.checkDeals(attempts);
      _this.windowEvents();
    },
    checkDeals: function(attempts) {
      var _this = this;

      // For dev env
      if(_this.checkUrl.length == 0) {
        _this.$form.submit();
        appCustomerSpace.Loader().stop({ $container: _this.$iframeContainer });
        return;
      }

      $.ajax({
        url: _this.checkUrl,
        method: "GET",
        success: function(response) {
            attempts++;
            if(attempts > 10 && response.response != 1) {
              appCustomerSpace.Loader().error({ $container: _this.$iframeContainer, options: { style: { backdrop: { background: "#FFFFFFCC" } }, text: "Synchronisation des contrats impossible, veuillez contacter un conseiller.", error: { persisted: true } } });
              return;
            }
            if(response.response == 1) {
              _this.$form.submit();
              appCustomerSpace.Loader().stop({ $container: _this.$iframeContainer });
              return;
            }
            setTimeout(function() { _this.checkDeals(attempts) }, 1000);
        },
        error: function() {
            appCustomerSpace.Loader().error({ $container: _this.$iframeContainer, options: { style: { backdrop: { background: "#FFFFFFCC" } }, text: "Synchronisation des contrats impossible, veuillez contacter un conseiller.", error: { persisted: true } } });
        }
      });
    },
    windowEvents: function() {
      var _this = this;

      window.addEventListener('message', function(event) {
        if(event.origin !== _this.origin) { return false; }
        // If multiple iframes, the event.source should be passed below in each function
        if(event.data.height > 0) { _this.resize(event.data.height) };
        if(event.data.code) { _this.messageCodesCallback(event.data.code) };
        if(event.data.type) { _this.messageTypesCallback(event.data.type) };
      });
    },
    resize: function(value) {
      var _this = this;
      _this.$iframeContainer.css("height", `${value}px`);
    },
  }

  return PlatformPaymentIframe;

})();
